import { ThemeIcon } from '@zorro/design-system/v2/ThemeIcon';
import { Group, Icon, Stack, Text } from '@zorro/web/design-system';
import { getPaymentMethodSelectOptions } from '@zorro/web/shared-ui';
import { useMonolithQuery } from '@zorro/web/ui-utils';

type Props = {
  employeeId: string;
  onboardingPeriodId: string;
  isDon?: boolean;
};

export const PaymentMethodType = ({
  employeeId,
  onboardingPeriodId,
  isDon = false,
}: Props) => {
  const {
    data: paymentMethodDetails,
    isLoading: isLoadingPaymentMethodDetails,
  } = useMonolithQuery({
    method: 'paymentsControllerEmployeePaymentMethodDetails',
    params: [employeeId, { onboardingPeriodId }],
  });

  if (isLoadingPaymentMethodDetails || !paymentMethodDetails) {
    return null;
  }

  const selectedOption = getPaymentMethodSelectOptions(isDon).find(
    (option) => option.value === paymentMethodDetails.type
  );

  if (!selectedOption) {
    return null;
  }

  return (
    <Group wrap="nowrap" gap="md">
      <ThemeIcon size="40" color="indigo">
        <Icon icon={selectedOption.icon} />
      </ThemeIcon>
      <Stack gap={0}>
        <Text fw={600} size="md">
          {selectedOption.label}
        </Text>
        <Text size="sm" c="var(--color-text-default-secondary)">
          {selectedOption.description}
        </Text>
      </Stack>
    </Group>
  );
};
